<template>
  <div class="speakers-page inner">
    <site-menu theme="dark" class="menu"/>
    <div class="content">
      <div class="speaker" v-for="speaker in speakers">
        <speaker :details="speaker" />
      </div>
    </div>
  </div>
</template>
<script>
  import SiteMenu from '@/components/SiteMenu.vue'
  import Speaker from '@/components/Speaker'
  import speakers from '@/lib/speakers'

  export default {
    name: 'speakers-page',
    components: { SiteMenu, Speaker },
    data() {
      return { speakers }
    },
  }
</script>
<style lang="scss" scoped>
  .content {
    padding: 50px 0;
    position: relative;
    overflow: hidden;
  }
  .speaker {
    padding-bottom: 40px;
  }
</style>
